import { CovalentBalanceItem } from '@shared/types/frontend';
import { FaArrowLeft } from 'react-icons/fa';
import { TiDelete } from 'react-icons/ti';
import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from '@/components/ui/resizable';
import AssetLogo from '@/components/shared/AssetLogo';
export default function PercentageView({
  toAssets,
  setSelectPercentage,
  setSelectToAsset,
  setToAssets,
  amount
}: {
  toAssets: CovalentBalanceItem[];
  setSelectPercentage: (_: boolean) => void;
  setSelectToAsset: (_: boolean) => void;
  setToAssets: (_: CovalentBalanceItem[]) => void;
  amount: number | string;
}) {
  return <div className='flex flex-col h-full relative max-lg:pb-16' data-sentry-component="PercentageView" data-sentry-source-file="PercentageView.tsx">
      <nav className='h-[48px] w-full border-b border-genius-blue flex justify-between items-center px-2 text-genius-cream'>
        <button className='flex items-center' onClick={() => {
        setSelectPercentage(false);
        setSelectToAsset(true);
      }}>
          <FaArrowLeft size={20} data-sentry-element="FaArrowLeft" data-sentry-source-file="PercentageView.tsx" />
          <p className='text-base font-medium ml-2'>Choose amounts</p>
        </button>
        <div className='flex font-medium text-sm items-center gap-x-4'>
          <p>PRICE</p>
          <p>TOKEN</p>
          <p className='bg-genius-blue px-4 py-2 rounded-sm'>USD</p>
        </div>
      </nav>
      <div className='overflow-auto no-scrollbar'>
        {toAssets?.map((assetItem, index) => {
        return <div key={`${assetItem.contract_address}-${index}`} className='flex items-center justify-between px-4 py-4 border-b-2 border-b-genius-blue'>
              <div className='flex items-center gap-3'>
                <div className='flex h-full shrink-0 relative items-center'>
                  <div className='text-genius-cream hover:cursor-pointer hover:scale-105 text-sm mr-4 font-medium' onClick={() => {
                setToAssets(prev => {
                  return prev.filter((_, i) => i !== index);
                });
              }}>
                    <TiDelete className='text-xl' />
                  </div>
                  <AssetLogo asset={assetItem} showName variant='table' truncate={false} />
                </div>
              </div>
              <div className='flex flex-col text-xs text-genius-cream/60'>
                {((typeof amount === 'string' ? parseFloat(amount) : amount) * (assetItem.percentage / 100))?.toFixed(2)}{' '}
                USD{' '}
              </div>
            </div>;
      })}
      </div>

      <div className={`flex flex-col p-4 max-lg:h-1/2`}>
        <ResizablePanelGroup onLayout={layout => {
        setToAssets(prev => {
          return prev.map((x, idx) => {
            return {
              ...x,
              percentage: layout?.[idx]
            };
          });
        });
      }} direction='vertical' className='max-w-md rounded-lg border  ' data-sentry-element="ResizablePanelGroup" data-sentry-source-file="PercentageView.tsx">
          {toAssets.map((_, idx) => {
          return <>
                <ResizablePanel className='flex items-center justify-between text-genius-cream px-4 ' defaultSize={toAssets?.[idx]?.percentage}>
                  {/* images */}
                  <div className='flex items-center gap-4'>
                    <AssetLogo asset={toAssets?.[idx]} showName variant='table' truncate={false} />
                  </div>
                  <div className='flex flex-col'>
                    <p className='text-xs text-genius-cream/60'>
                      {toAssets?.[idx]?.percentage?.toFixed(2)}%
                    </p>
                  </div>
                </ResizablePanel>
                {idx < toAssets.length - 1 && <ResizableHandle withHandle />}
              </>;
        })}
        </ResizablePanelGroup>
      </div>

      <div className='fixed bottom-2 max-lg:bottom-12 px-2 w-full border-t-2 border-genius-blue pt-4 max-lg:text-sm max-lg:pt-2'>
        <div className='hover:cursor-pointer md:hover:bg-genius-purple md:hover:text-genius-pink transition-all duration-300 rounded-full bg-genius-pink text-genius-indigo w-full p-3 max-lg:p-2 text-center font-medium' onClick={() => {
        setSelectToAsset(false);
        setSelectPercentage(false);
      }}>
          Confirm
        </div>
      </div>
    </div>;
}